import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCategories, deleteCategory } from "../../../actions/admin/category";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import CategoryItem from "./CategoryItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Category Name", width: "tw:w-auto" },
  { key: "action", title: "Action", width: "tw:w-[140px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const CategoryList = () => {
  const category_state = useSelector((state) => state.category);
  const { loading, categories } = category_state;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  const delCatfromPopup = () => {
    dispatch(deleteCategory(delId));
    setDelId(null);
  };

  return (
    <AdminPage title="Category List" actions={<AdminCreateButton to="/admin/addcategory" label="Add Category" />}>
      <AdminDeleteModal
        show={!!delId}
        title="Delete this category?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={delCatfromPopup}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={720}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!categories?.length}
        emptyText="No categories found."
      >
        {categories?.map((item, index) => (
          <CategoryItem key={item._id} category={item} count={index} deleteCategory={setDelId} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default CategoryList;
